import useSWR from "swr";
import useSWRMutation from "swr/mutation";
import { mapRawToTestLabel } from "@/mappers/testLabel";
import {
  ArchiveTestLabel,
  CreateTestLabel,
  DeleteTestLabel,
  RawTestLabel,
  UpdateTestLabel,
} from "@/types/testLabel";
import {
  SWRApiError,
  swrConfigOptions,
  UpdaterParams,
  useDeleter,
  useFetcher,
  useMutater,
  useUpdater,
} from "./swr";

export const useTestLabels = () => {
  const fetcher = useFetcher();

  const { data = [], ...rest } = useSWR<RawTestLabel[], SWRApiError>(
    { url: "/test_labels" },
    fetcher,
    swrConfigOptions,
  );

  return { data: data.map(mapRawToTestLabel), ...rest };
};

export const useTestLabel = (id?: number) => {
  const fetcher = useFetcher();

  const { data, ...rest } = useSWR<RawTestLabel, SWRApiError>(
    id ? { url: `/test_labels/${id}` } : null,
    fetcher,
    swrConfigOptions,
  );

  return { data: data ? mapRawToTestLabel(data) : null, ...rest };
};

export const useTestLabelsByMask = (maskId?: string) => {
  const fetcher = useFetcher();

  const { data = [], ...rest } = useSWR<RawTestLabel[], SWRApiError>(
    maskId ? { url: `/test_labels/mask/${maskId}` } : null,
    fetcher,
    swrConfigOptions,
  );

  return { data: data.filter(Boolean).map(mapRawToTestLabel), ...rest };
};

export const useCreateTestLabel = () => {
  const mutater = useMutater();

  return useSWRMutation<any, SWRApiError, string, CreateTestLabel>("/test_labels", mutater);
};

export const useUpdateTestLabel = () => {
  const updater = useUpdater();

  return useSWRMutation<void, SWRApiError, UpdaterParams, UpdateTestLabel>(
    { url: "/test_labels" },
    updater,
  );
};

export const useArchiveTestLabel = () => {
  const mutater = useMutater();

  return useSWRMutation<void, SWRApiError, string, ArchiveTestLabel>(
    "/test_labels/archive",
    mutater,
  );
};

export const useDeleteTestLabel = () => {
  const deleter = useDeleter();

  return useSWRMutation<void, SWRApiError, string, DeleteTestLabel>("/test_labels", deleter);
};
